import React from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { Button } from './ui/button';
import Confidence from './Confidence';

// One reconcilable field: PM value → payer-verified value, with one-click apply.
export default function DiffRow({ disc, onApply, onDismiss }) {
  const resolved = disc.status && disc.status !== 'pending';
  return (
    <div className="flex flex-wrap items-center gap-3 py-3 border-b border-slate-100 last:border-0">
      <div className="w-28 shrink-0">
        <div className="text-xs font-medium text-slate-700">{disc.label || disc.field}</div>
        <div className="text-[10px] text-slate-400 uppercase tracking-wide">from {disc.source}</div>
      </div>
      <div className="flex items-center gap-2 flex-1 min-w-0">
        <span className="text-sm text-slate-400 line-through truncate">{disc.pmsValue}</span>
        <ArrowRight className="h-3.5 w-3.5 text-slate-400 shrink-0" />
        <span className="text-sm font-semibold text-slate-900 truncate">{disc.payerValue}</span>
      </div>
      <Confidence value={disc.confidence} label="match" showLabel={false} />
      <div className="shrink-0">
        {resolved ? (
          <span className="inline-flex items-center gap-1 text-xs text-emerald-700 font-medium">
            <Check className="h-3.5 w-3.5" />{disc.status === 'applied' ? 'Applied' : 'Dismissed'}
          </span>
        ) : (
          <div className="flex gap-1.5">
            <Button size="sm" className="h-7 bg-brand-600 hover:bg-brand-700 text-white" onClick={onApply}>Apply to PM</Button>
            <Button size="sm" variant="ghost" className="h-7 text-slate-500" onClick={onDismiss}>Keep</Button>
          </div>
        )}
      </div>
    </div>
  );
}
